import Vue from 'vue'
import VueRouter from 'vue-router'
import StockView from '@/views/StockView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: StockView,
  },
  {
    path: '*',
    redirect: '/',
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
